import bgPortfolioSrc from '@assets/images/bg-portfolio.jpg';

import { SignedInPageLayout } from '@/layout/signed-in-page';
import { SignedInPageLayoutContentContainer } from '@/layout/signed-in-page/components';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

import { About, Help, Hero } from './components';

export const BuyerPortfolioPage = () => {
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <div className='bg-cover full-bleed-x' style={{ backgroundImage: `url(${bgPortfolioSrc})` }}>
        <SignedInPageLayoutContentContainer>
          <Hero />
        </SignedInPageLayoutContentContainer>
      </div>
      <div className='full-bleed-x'>
        <SignedInPageLayoutContentContainer>
          <div className='flex flex-col gap-8 lg:flex-row'>
            <About className='lg:w-1/2' />
            <Help className='lg:w-1/2' />
          </div>
        </SignedInPageLayoutContentContainer>
      </div>
    </SignedInPageLayout>
  );
};
